// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linearLoader_root__DwbD9 {\n  width: 100%;\n  height: 10px; }\n", ""]);
// Exports
exports.locals = {
	"root": "linearLoader_root__DwbD9"
};
module.exports = exports;
